import { render, staticRenderFns } from "./DocumentoCard.vue?vue&type=template&id=eaee10a2&scoped=true"
import script from "./DocumentoCard.vue?vue&type=script&lang=js"
export * from "./DocumentoCard.vue?vue&type=script&lang=js"
import style0 from "./DocumentoCard.vue?vue&type=style&index=0&id=eaee10a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaee10a2",
  null
  
)

export default component.exports